import { useInfiniteQuery, useMutation, useQuery } from 'react-query';
import {
  CreateKitRequest,
  EditKitRequest,
  KitsQueryFilters,
} from './Kits.types';
import { notification } from 'antd';
import {
  countKit,
  createKit,
  deleteKit,
  editKit,
  listKitsReduced,
} from './Kits.service';
import notificationError from '@/utils/functions/notificationError';
import { DEFAULT_ORDER, DEFAULT_ROWS } from '..';
import { queryClient } from '@/Root';
import { useQueryChanel } from '@/contexts/QueryChanelProvider';

export function useListKitReduced(params?: KitsQueryFilters, enabled = true) {
  const cache = queryClient.getQueryData(['kit/list/reduced', { ...params }]);

  return useInfiniteQuery(
    ['kit/list/reduced', { ...params }],
    ({ pageParam }) => {
      const req: KitsQueryFilters = {
        nextToken: pageParam,
        order: params?.order || DEFAULT_ORDER,
        rows: params?.rows || DEFAULT_ROWS,
        ...params,
      };

      return listKitsReduced(req);
    },
    {
      enabled: enabled && !cache,
      getNextPageParam: (lastPage) => lastPage.nextToken,
      onError(error) {
        notificationError(error);
      },
    },
  );
}

export function useCreateKit() {
  const queryChanel = useQueryChanel();

  return useMutation((obj: CreateKitRequest) => createKit(obj), {
    onSuccess() {
      notification.success({
        message: 'Sucesso!',
        description: 'Kit criado com sucesso!',
      });

      queryChanel({
        resetQueries: [['kit/list/reduced'], ['kit/count']],
      });
    },

    onError(error) {
      notificationError(error);
    },
  });
}

export function useEditKit() {
  const queryChanel = useQueryChanel();

  return useMutation((obj: EditKitRequest) => editKit(obj), {
    onSuccess() {
      notification.success({
        message: 'Sucesso!',
        description: 'Kit editado com sucesso!',
      });

      queryChanel({
        invalidateQueries: [['workorder/kit/detail']],
        resetQueries: [['kit/list/reduced']],
      });
    },

    onError(error) {
      notificationError(error);
    },
  });
}

export function useDeleteKit() {
  const queryChanel = useQueryChanel();

  return useMutation((id: number) => deleteKit(id), {
    onSuccess() {
      notification.success({
        message: 'Sucesso!',
        description: 'Kit removido!',
      });

      queryChanel({
        resetQueries: [['kit/list/reduced'], ['kit/count']],
      });
    },

    onError(error) {
      notificationError(error);
    },
  });
}

export function useCountKit() {
  const cache = queryClient.getQueryData(['kit/count']);

  return useQuery(['kit/count'], () => countKit(), {
    enabled: !cache,
    onError(err) {
      notificationError(err);
    },
  });
}
